import { render, staticRenderFns } from "./PlayerDetailsDialog.vue?vue&type=template&id=dd0c3aa6&scoped=true"
import script from "./PlayerDetailsDialog.vue?vue&type=script&lang=js"
export * from "./PlayerDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./PlayerDetailsDialog.vue?vue&type=style&index=0&id=dd0c3aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0c3aa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VBtn,VCard,VCol,VIcon,VRow,VTextField})
